import React from 'react';
import AccordionMenu from '../AccordionMenu';
import styles from './category.module.css';

const mockData = (type) => {
    //TODO: TEST DATA
    return {
      type: type,
      headerLink: "#",
      title: type.toUpperCase(),
      courses: [
       {link: "#", title: "Medicine"},
       {link: "#", title: "Psychology"},
       {link: "#", title: "Health and Safety"},
       {link: "#", title: "Nursing"}
      ]
   };
}

const CategoryGallery = () => {
    const categories = [ mockData("medicine"),
      mockData("engineering"),
      mockData("social"),
      mockData("creative"),
      mockData("science"),
      mockData("business")];

    return (
      <div className={styles.body}>
        <section className={styles.section}>
          <div className={styles.grid}>
        {categories.map(cat => (<AccordionMenu category={cat} />))}
          </div>
        </section>
      </div>
    );
}

export default CategoryGallery;



// WEBPACK FOOTER //
// ./src/components/CategoryGallery/index.js